module.exports = __webpack_public_path__ + "static/media/angle-double-down.5a8f7d99.svg";